import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "T\xFCrk\xE7e",
  code: "tr",
  messages: {
    alert: {
      close: "Kapat"
    },
    authForm: {
      hidePassword: "\u015Eifreyi gizle",
      showPassword: "\u015Eifreyi g\xF6ster",
      submit: "Devam et"
    },
    banner: {
      close: "Kapat"
    },
    calendar: {
      nextMonth: "Sonraki ay",
      nextYear: "Sonraki y\u0131l",
      prevMonth: "\xD6nceki ay",
      prevYear: "\xD6nceki y\u0131l"
    },
    carousel: {
      dots: "G\xF6r\xFCnt\xFClenecek slayd\u0131 se\xE7in",
      goto: "{slide}. slayda git",
      next: "Sonraki",
      prev: "\xD6nceki"
    },
    chatPrompt: {
      placeholder: "Buraya mesaj\u0131n\u0131z\u0131 yaz\u0131n..."
    },
    chatPromptSubmit: {
      label: "G\xF6nder"
    },
    colorMode: {
      dark: "Koyu",
      light: "A\xE7\u0131k",
      switchToDark: "Koyu moda ge\xE7",
      switchToLight: "A\xE7\u0131k moda ge\xE7",
      system: "Sistem"
    },
    commandPalette: {
      back: "Geri",
      close: "Kapat",
      noData: "Veri yok",
      noMatch: "E\u015Fle\u015Fen veri yok",
      placeholder: "Bir komut yaz\u0131n veya arama yap\u0131n..."
    },
    contentSearch: {
      links: "Ba\u011Flant\u0131lar",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "Ara..."
    },
    contentToc: {
      title: "Bu sayfada"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "Ara..."
    },
    dashboardSidebarCollapse: {
      collapse: "Kenar \xE7ubu\u011Funu daralt",
      expand: "Kenar \xE7ubu\u011Funu geni\u015Flet"
    },
    dashboardSidebarToggle: {
      close: "Kenar \xE7ubu\u011Funu kapat",
      open: "Kenar \xE7ubu\u011Funu a\xE7"
    },
    error: {
      clear: "Ana sayfaya d\xF6n"
    },
    fileUpload: {
      removeFile: "{filename} kald\u0131r"
    },
    header: {
      close: "Men\xFCy\xFC kapat",
      open: "Men\xFCy\xFC a\xE7"
    },
    inputMenu: {
      create: '"{label}" olu\u015Ftur',
      noData: "Veri yok",
      noMatch: "E\u015Fle\u015Fen veri yok"
    },
    inputNumber: {
      decrement: "Azalt",
      increment: "Artt\u0131r"
    },
    modal: {
      close: "Kapat"
    },
    pricingTable: {
      caption: "Fiyat planlar\u0131n\u0131 kar\u015F\u0131la\u015Ft\u0131r"
    },
    prose: {
      codeCollapse: {
        closeText: "Daralt",
        name: "kod",
        openText: "Geni\u015Flet"
      },
      collapsible: {
        closeText: "Gizle",
        name: "\xF6zellikler",
        openText: "G\xF6ster"
      },
      pre: {
        copy: "Kodu panoya kopyala"
      }
    },
    selectMenu: {
      create: '"{label}" olu\u015Ftur',
      noData: "Veri yok",
      noMatch: "E\u015Fle\u015Fen veri yok",
      search: "Ara..."
    },
    slideover: {
      close: "Kapat"
    },
    table: {
      noData: "Veri yok"
    },
    toast: {
      close: "Kapat"
    }
  }
});
